module.exports = __webpack_public_path__ + "static/media/banff-35.65305eaa.jpg";